import { definePreset } from '../types/portal-settings';

// A mapping portal is fleet-first: no jobs, no items, just where the units are
// and where they have been. Its static builds are repointable at runtime, which
// is how a mapping tenant moves backend without a rebuild.
export default definePreset({
	homePage: 'fleet',
	pages: ['fleet', 'unitMap', 'units', 'settings'],
	allowApiOriginOverride: true,
	features: {
		twoFactorAuth: true,
		unitMapping: { enabled: true, allowMockData: true, routingStrategy: 'simple' },
	},
});
